<template>
    <div class="row">
   <div class="col-md-12 mb-5 mt-3">
        <h1 class="m-0 text-center error-status">502</h1>
        <h4 class="text-center m-0">Maintenance</h4>
        <p class="text-center">The server is currently unable to handle the request due to a temporary overloading or maintenance of the server. The implication is that this is a temporary condition which will be alleviated after some delay.</p>
   </div>
</div>

</template>

<script>
export default {
    name: 'Maintenance',
}
</script>